import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FiChecklist2SyncService } from '@fi-shared/checklist/fi-checklist2-sync.service';

@Injectable()
export class Checklists2SystemNotificationsService {
    get notCompletedChecklistsV2Count$(): Observable<number> {
        return this.fiChecklist2SyncService.notCompletedChecklistsV2Count$;
    }

    get notCompletedChecklistV2AuditCount$(): Observable<number> {
        return this.fiChecklist2SyncService.notCompletedChecklistV2AuditCount$;
    }

    constructor(private fiChecklist2SyncService: FiChecklist2SyncService) {}
}
